import { useQuery } from "@apollo/client";

import { GqlPlannerV2VisitGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";
import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";

import useRequireCurrentProject from "../hooks/useRequireCurrentProject";
import { ProjectVisitList_GetAllDocument } from "../screens/ProjectVisitListScreen/queries.generated";

export function useProjectVisitListGetAll(params: GqlPlannerV2VisitGetAllParams) {
    const { client } = useRequireCurrentClient();
    const { project } = useRequireCurrentProject();

    const { data, loading, error } = useQuery(ProjectVisitList_GetAllDocument, {
        variables: {
            clientId: client.id,
            projectId: project.id,
            params: params,
        },
        fetchPolicy: "cache-and-network",
    });

    const queryInfo = data?.plannerV2VisitGetAll.queryInfo;
    const [filterOptions, total] = useCacheFilterOptions(queryInfo?.filterOptions, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        total: total,
        sortableColumns: queryInfo?.sortableColumns,
        filterOptions: filterOptions,
        data: data?.plannerV2VisitGetAll.data,
    };
}
